module.exports = {
          srcSet: __webpack_public_path__ + "public/images/b807c72ad2d760179d32672be0ae1d3b-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/b807c72ad2d760179d32672be0ae1d3b-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/b807c72ad2d760179d32672be0ae1d3b-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/b807c72ad2d760179d32672be0ae1d3b-1774.jpg"},
          
          width: 1774,
          height: 887
        }